"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nft_filters_1 = require("@components/nft-filters");
const nft_token_card_list_1 = require("@components/nft-token-card-list");
const stub_cards_1 = require("@components/stub-cards");
const collection_hooks_1 = require("@hooks/collection.hooks");
const token_hooks_1 = require("@hooks/token.hooks");
const button_1 = require("@shared-modules/components/button");
const loader_1 = require("@shared-modules/components/loader");
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const react_collapse_1 = require("react-collapse");
const react_router_dom_1 = require("react-router-dom");
const collection_info_1 = __importDefault(require("./components/collection-info"));
const edit_collection_form_1 = __importDefault(require("./components/edit-collection-form"));
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const CollectionExplorerPage = () => {
    const { params: { id }, } = (0, react_router_dom_1.useRouteMatch)();
    const { data: collection, isCompleted, forceReload } = (0, collection_hooks_1.useCollectionById)(id);
    const [filters, setFilters] = (0, react_1.useState)();
    const [isEditMode, setIsEditMode] = (0, react_1.useState)(false);
    const closeCollection = () => {
        setIsEditMode(false);
        forceReload();
    };
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const { list: tokens, isFirstLoadCompleted, isLastPage, nextPage, } = (0, token_hooks_1.useTokenListByFilter)(Object.assign({ collectionId: id }, filters));
    const { data: { tradeVolume, tradedTokensCount } } = (0, collection_hooks_1.useCollectionStats)(id);
    return (React.createElement("div", { className: "p-collection-explorer-page" },
        React.createElement(react_collapse_1.UnmountClosed, { isOpened: isEditMode }, collection && React.createElement(edit_collection_form_1.default, { tradedTokensCount: tradedTokensCount, collection: collection, closeForm: closeCollection })),
        React.createElement(react_collapse_1.UnmountClosed, { isOpened: !isEditMode }, isCompleted ? (collection && React.createElement(collection_info_1.default, { tradedTokensCount: tradedTokensCount, collection: collection, volumes: tradeVolume, edit: () => setIsEditMode(true) })) : (React.createElement(loader_1.Loader, null))),
        React.createElement("div", { className: (0, classnames_1.default)("p-collection-explorer-page__content", {
                "p-collection-explorer-page__content--blur": isEditMode,
            }) },
            isEditMode && React.createElement("div", { className: "p-collection-explorer-page__locker" }),
            React.createElement("div", { className: "p-collection-explorer-page__filters" },
                React.createElement(nft_filters_1.NftFilters, { updateFilters: setFilters })),
            !isFirstLoadCompleted && (React.createElement("div", { className: "p-collection-explorer-page__loader" },
                React.createElement(loader_1.Loader, { scale: 1 }))),
            isFirstLoadCompleted && (React.createElement("div", { className: "p-collection-explorer-page__container" },
                React.createElement(nft_token_card_list_1.NFTTokenCardList, { list: tokens }),
                React.createElement(stub_cards_1.StubCards, null))),
            !isLastPage && (React.createElement("div", { className: "p-collection-explorer-page__button" },
                React.createElement(button_1.Button, { type: "thirtery", onClick: nextPage }, commonTranslator("loadMoreButton")))))));
};
exports.default = CollectionExplorerPage;
